<template>
  <div>
    <el-row :gutter="20" >
      <el-col :span="4">
        <el-input placeholder="合约单号" v-model="fetchParams.order_no"><el-button slot="append" icon="el-icon-search" @click="search"></el-button></el-input>
      </el-col>
      <el-col :span="3">
        <el-input placeholder="姓名" v-model="fetchParams.realname"><el-button slot="append" icon="el-icon-search" @click="search"></el-button></el-input>
      </el-col>
      <el-col :span="3">
        <el-input placeholder="手机号" v-model="fetchParams.connact_mobile"><el-button slot="append" icon="el-icon-search" @click="search"></el-button></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="健康顾问手机号" v-model="fetchParams.origin_mobile"><el-button slot="append" icon="el-icon-search" @click="search"></el-button></el-input>
      </el-col>
    </el-row>
    <div >
      <el-table
        :data="dataList"
        style="width: 100%">
        <el-table-column
          prop="id"
          label="id">
        </el-table-column>
        <el-table-column
          prop="order_no"
          label="合约单号">
        </el-table-column>
        <el-table-column
          label="用户"
          prop="realname">
        </el-table-column>
        <el-table-column
          label="手机号"
          prop="connact_mobile">
        </el-table-column>
        <el-table-column
          prop="origin_mobile"
          label="健康顾问手机号">
        </el-table-column>
        <el-table-column
          prop="money"
          label="返现金额">
        </el-table-column>
        <el-table-column
          prop="back_time_text"
          label="返现时间">
        </el-table-column>
        <el-table-column
          prop="created_text"
          label="创建时间">
        </el-table-column>
      </el-table>
      <div class="content-padded content-center" v-if="pagers.total>0">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="fetchParams.page"
          :page-sizes="[10,20,50,100]"
          :total="pagers.total"
          :page-size="fetchParams.pageSize">
        </el-pagination>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getInviteList} from '@/api/long'

export default {
  props: {
    isLoad: {
      type: Boolean,
      default: true
    },
  },
  provide() {
    return {
      refresh: this.getList
    }
  },
  data () {
    return {
      loading: false,
      dataList: [],
      pagers:{
        total: 0
      },
      status:'',
      pageSize:20,
      currentPage:1,
      fetchParams: {
        page: 1,
        order_no:'',
        realname:'',
        connact_mobile:'',
        pageSize: 20,
        origin_mobile:'',
      },
      multipleSelection:[],
      dialogTableVisible:false,
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  watch:{
    $route(to,from){
      this.getList()
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.fetchParams.page = val
      this.getList()
    },
    handleSizeChange (pageSize) {
      this.fetchParams.page = 1
      this.fetchParams.pageSize = pageSize
      this.getList()
    },
    getList () {
      this.loading = true
      getInviteList(this.fetchParams).then(res => {
        if(res.data.data.list.length > 0) {
          this.dataList = res.data.data.list
          this.pagers.total = res.data.data.total_count
          this.loading = false
        } else {
          this.dataList = []
          this.loading = false
        }
      })
        .catch( error => {
          this.loading = false
        })
    },
    search() {
      this.getList()
    },
  },
  mounted () {
    this.$nextTick(() => {
      if (this.isLoad) {
        this.getList()
      }
    })
  }
}

</script>
<style scoped lang="scss">
.el-icon-edit {
  cursor: pointer;
}
.coupon-list {
  margin-top: 10px;
}
.coupon-item {
  position: relative;
  height: 130px;
  padding: 25px 20px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #dadadd;
  border-radius: 5px;
  text-align: center;
  font-size: 14px;
  width: 19%;
  float: left;
  margin: .5%;
  &.coupon-add {
    padding-top: 20px;
    cursor: pointer;
    i {
      font-size: 40px;
    }
    :last-child { margin-top: 10px; }
  }
  .price {
    font-size: 24px;
  }
  .color-gray {
    color: #99A9BF;
  }
  .color-gray-deep {
    color: #8492A6;
  }
  .item-code {
    display: inline-block;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  span.icon-triangle {
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    border-top: 34px solid #20a0ff;
    border-left: 34px solid transparent;
    color: #fff;
  }
  label {
    position: absolute;
    top: -34px;
    right: 0;
    width: 20px;
    height: 20px;
    line-height: 20px;
  }
}
.item-bg {
  position: absolute;
  left: 0;
  bottom: -101%;
  width: 100%;
  height: 100%;
  background: rgba(241, 244, 246, .9);
  text-align: left;
  border-radius: 5px;
  padding-top: 8px;
  transition: all .4s ease;
  p {
    padding: 0 10px;
  }
  .item-operate {
    position: absolute;
    left: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .4);
    width: 100%;
    padding: 4px 0;
    text-align: center;
    cursor: pointer;
    a { color: #fff; }
  }
}
.coupon-item:hover {
  .item-bg {
    bottom: 0;
  }
}
.coupon-type-item {
  position: relative;
  padding: 30px 10px;
  border: 1px solid #ff5000;
  color: #ff5000;
  border-radius: 5px;
  text-align: center;
  margin-bottom: 20px;
  background: #fff;
  overflow: hidden;
  cursor: pointer;
  &:first-child {
    font-size: 18px;
  }
  .coupon-type-desc {
    position: absolute;
    width: 100%;
    height: 100%;
    bottom: -100%;
    left: 0;
    padding: 10px 0;
    background: #ff5000;
    color: #fff;
    font-size: 18px;
    transition: all .4s ease;
    div:last-child {
      width: 70%;
      margin: 8px auto 0;
      font-size: 12px;
    }
  }
  &:hover {
    .coupon-type-desc {
      bottom: 0;
    }
  }
}

.coupon-type-item, .sendout-item {
  overflow: hidden;
  .icon-checked {
    display: none;
    width: 100px;
    height: 25px;
    transform: rotate(35deg);
    position: absolute;
    font-size: 14;
    top: 5px;
    right: -25px;
    font-size: 20px;
    color: #fff;
    background: #ff5000;
    i {
      transform: rotate(-35deg);
    }
  }
  &.checked {
    .icon-checked {
      display: block;
    }
  }

  &:hover .icon-checked {
    background: #fff;
    i {
      color: #ff5000;
    }
  }
}
.store-pop {
  padding: 20px 15px;
  .store-content {
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?db06dc56